import PageTypeFactory from '../../page/get_page_type';
import GA_EVENTS from './ga_constants';
import { setBehaviourEvent } from './ga_interface';

function approved() {
    const category = GA_EVENTS.geolocation.category;
    const action = GA_EVENTS.geolocation.actions.approved;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label });
}

function denied() {
    const category = GA_EVENTS.geolocation.category;
    const action = GA_EVENTS.geolocation.actions.denied;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label });
}

export {
    approved,
    denied,
};
